export default (t) => [
  {
    text: t('Payment Method'),
    value: 'payment_method',
    sortable: false,
    width: 170
  },
  {
    text: t('Account Name'),
    value: 'account_name',
    sortable: false
  },
  {
    text: t('Status'),
    value: 'active',
    sortable: false,
    width: 90
  },
  {
    text: t('Created At'),
    value: 'created_at',
    sortable: false,
    width: 160
  },
  {
    text: t('Action'),
    value: 'action',
    sortable: false,
    width: 100
  },
];
